import { ApolloError, DocumentNode, gql } from '@apollo/client';
import { CampaignAlert } from 'modules/campaigns/alerts/types';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';

export const campaignAlertsQuery = gql`
  query getCampaignAlerts($campaignId: Long!) {
    campaignAlerts(id: $campaignId) {
      id
      campaignType
      messageMedium
      metricName
      comparisonOperator
      threshold
      frequency
      status
    }
  }
`;

type UseCampaignAlertsResponse = {
  errorMessage?: ApolloError;
  hasError: boolean;
  isLoading: boolean;
  refetch: () => void;
  results: CampaignAlert[];
};

export const useQueryCampaignAlerts = (
  options?: Record<string, any>,
  query: DocumentNode = campaignAlertsQuery,
): UseCampaignAlertsResponse => {
  const queryOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      ...options,
    }),
    [options],
  );

  const {
    data,
    errorMessage,
    isLoading,
    error: hasError = false,
    refetch,
  } = useGraphql(query, queryOptions);

  const results = data?.campaignAlerts ?? [];

  return {
    errorMessage,
    hasError,
    isLoading,
    results,
    refetch,
  };
};
